import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";
import { getFunctions } from "firebase/functions";
// Temporarily disable App Check to unblock uploads/login while configuring keys/domains
// import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

// Your Firebase config will go here - you'll need to create a new Firebase project
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

console.log('🏛️ Initializing Firebase for Compassion Course Foundation');
console.log('🔧 Firebase config:', {
  projectId: firebaseConfig.projectId,
  authDomain: firebaseConfig.authDomain,
  apiKey: firebaseConfig.apiKey ? `${firebaseConfig.apiKey.substring(0, 10)}...` : 'MISSING',
  storageBucket: firebaseConfig.storageBucket
});
if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
  console.error('❌ Missing Firebase env vars. Ensure VITE_FIREBASE_* are set at build time.');
  console.error('Required variables:', {
    VITE_FIREBASE_API_KEY: !!firebaseConfig.apiKey,
    VITE_FIREBASE_PROJECT_ID: !!firebaseConfig.projectId,
    VITE_FIREBASE_AUTH_DOMAIN: !!firebaseConfig.authDomain
  });
}

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');
// App Check temporarily disabled. Re-enable after reCAPTCHA v3 keys/domains are correctly configured.
// if (typeof window !== 'undefined') {
//   const siteKey = (import.meta as any).env?.VITE_FIREBASE_APPCHECK_KEY as string | undefined;
//   if (siteKey) {
//     try {
//       initializeAppCheck(app, {
//         provider: new ReCaptchaV3Provider(siteKey),
//         isTokenAutoRefresh: true
//       });
//       console.log('✅ App Check initialized');
//     } catch (e) {
//       console.warn('⚠️ App Check init failed:', e);
//     }
//   } else {
//     console.warn('⚠️ VITE_FIREBASE_APPCHECK_KEY not set; enable to satisfy Storage/App Check if enforced.');
//   }
// }
// Only initialize analytics in browser and if measurementId is provided
export const analytics = (typeof window !== 'undefined' && firebaseConfig.measurementId)
  ? getAnalytics(app)
  : undefined as unknown as ReturnType<typeof getAnalytics>;

console.log('✅ Firebase services initialized for CCF');

export default app;
// Force rebuild
